import { Modal, ModalProps } from 'antd';
import './style.scss';
import CustomButton from '../buttons/CustomButton';
import SvgIconError from '../@svg/SvgIconError';
import { useNavigate } from 'react-router-dom';
import { USER_ROUTE_PATH } from '../../constants/router';

interface customModalProps extends ModalProps {
  className?: string;
  isOpen: boolean;
  handleCancelModal: () => void;
  isLink?: boolean;
  children?: React.ReactNode;
  nameModal?: string;
  idItemDetail?: number;
}

const ModalError = (props: customModalProps) => {
  const { isOpen, className, handleCancelModal, isLink, children, nameModal, idItemDetail, ...restProps } = props;
  const navigate = useNavigate();
  const handleOpenChatSupport = () => {
    const tabKey = 'tabSelect';

    if (nameModal?.includes('LABEL_CREATED_ERROR')) {
      sessionStorage.setItem(tabKey, 'TASK');
      navigate(`${USER_ROUTE_PATH.RETURN_ITEM_DETAIL}/${idItemDetail}`);
    } else {
      document?.getElementById('btn-chat-support-id')?.click();
    }

    handleCancelModal();
  };

  return (
    <Modal
      className={`errors-modal ${className}`}
      open={isOpen}
      onCancel={handleCancelModal}
      closeIcon={false}
      centered
      {...restProps}
      footer={[]}
    >
      <div className="title">
        <SvgIconError />
        <div className="content">{children}</div>
      </div>
      {isLink && (
        <div className="link" onClick={handleOpenChatSupport}>
          <span>問い合わせ</span>
        </div>
      )}
      <CustomButton onClick={handleCancelModal} className="custom-button__cancel">
        閉じる
      </CustomButton>
    </Modal>
  );
};

export default ModalError;
